import React from 'react'
import { ThemeToggler } from 'gatsby-plugin-dark-mode'
import Toggle from 'react-toggle'
import "./index.scss"

const Sun = () => <img src={require("../../static/sun.svg")} alt="light" title="light mode"></img>
const Moon = () => <img src={require("../../static/moon.svg")} alt="dark" title="dark mode"></img>

export const ThemeToggle = () => (
    <ThemeToggler>
        {({ theme, toggleTheme }) => (
            <label className={'theme-toggle-container'}>
                <Toggle
                    checked={theme === 'dark'}
                    icons={{
                        checked: <Sun />,
                        unchecked: <Moon />,
                    }}
                    onChange={e => toggleTheme(e.target.checked ? 'dark' : 'light')} />
            </label>
        )}
    </ThemeToggler>
)
